<template>
  <v-dialog
    persistent
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar class="primary" dense flat>
        <v-toolbar-title
          class="white--text mx-auto text-center controlled-font"
          >{{ title }}</v-toolbar-title
        >
      </v-toolbar>
      <!-- <v-card-title class="public-blue white--text">{{ title }}</v-card-title> -->
      <v-card-text
        v-show="!!message"
        class="text--primary pa-4 controlled-font mx-auto text-center message"
      >
        <span class="controlled-font" v-html="message"></span>
      </v-card-text>
      <v-card-actions class="pt-0 mx-auto text-center">
        <v-spacer class="hidden-xs-only"></v-spacer>
        <v-btn
          class="primary white--text controlled-font"
          text
          @click.native="agree"
          >OK</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "primary",
        width: 500,
        zIndex: 200,
      },
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-btn {
  color: white !important;
  max-width: 150px !important;
}
.v-card .message {
  min-height: 75px;
}
</style>
